import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';
import { AppPathConsts } from './shared/AppPathConsts';
import { AppPermissionConsts } from './shared/AppPermissionConsts';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
        const initializerFn = (configureRoutes)(inject(RoutesService));
        return initializerFn();
      }),
];

function configureRoutes(routes: RoutesService): () => void {
  return () => {
    routes.add([
      {
        path: '/',
        name: '::Menu:Home',
        iconClass: 'fas fa-home',
        order: 1,
        layout: eLayoutType.application,
      },
      ...evaluationRoutes(2),
      ...calibrationRoutes(3),
      ...templateRoutes(4),
      ...operatorRoutes(5),
      ...operatorEvaluationSummariesRoutes(6),
      ...reportRoutes(7),
      ...configurationRoutes(8),
    ]);
  };
}

const configurationRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.ConfigurationPrefix),
    name: '::Configuration',
    iconClass: 'fas fa-cog',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.ConfigurationDefault,
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.RolePlaces}`),
    name: '::RolePlaces',
    order: 1,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.RolePlaceDefault,
    iconClass: 'fas fa-globe',
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.InformationSources}`),
    name: '::InformationSources',
    order: 2,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.InformationSourceDefault,
    iconClass: 'fas fa-info',
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.Places}`),
    name: '::Places',
    order: 3,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.PlaceDefault,
    iconClass: 'fas fa-home',
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.Shifts}`),
    name: '::Shifts',
    order: 4,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.ShiftDefault,
    iconClass: 'far fa-clock',
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.AnswerGroups}`),
    name: '::AnswerGroups',
    order: 5,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.AnswerGroupDefault,
    iconClass: 'fas fa-list-ol',
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.QuestionGroups}`),
    name: '::QuestionGroups',
    order: 6,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.QuestionGroupDefault,
    iconClass: 'fas fa-layer-group',
  },
  {
    path: asMenuPath(`${AppPathConsts.ConfigurationPrefix}/${AppPathConsts.Questions}`),
    name: '::Questions',
    order: 7,
    parentName: '::Configuration',
    requiredPolicy: AppPermissionConsts.QuestionDefault,
    iconClass: 'fas fa-question',
  },
];

const templateRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.TemplatePrefix),
    name: '::Templates',
    iconClass: 'far fa-file',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.TemplateDefault,
  },
];

const operatorRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.OperatorsPrefix),
    name: '::Operators',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.OperatorDefault,
    iconClass: 'fas fa-id-badge',
  },
];

const evaluationRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.EvaluationPrefix),
    name: '::Evaluations',
    iconClass: 'far fa-address-book',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.EvaluationListVisualization,
  },
];

const calibrationRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.CalibrationPrefix),
    name: '::Calibrations',
    iconClass: 'far fa-chart-bar',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.CalibrationDefault,
  },
];

const reportRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.ReportPrefix),
    name: '::Reports',
    iconClass: 'far fa-folder-open',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.ReportDefault,
  },
  {
    path: asMenuPath(`${AppPathConsts.ReportPrefix}/${AppPathConsts.ExportResults}`),
    name: '::ExportResults',
    order: 1,
    parentName: '::Reports',
    requiredPolicy: AppPermissionConsts.ExportReportResultDefault,
    iconClass: 'fas fa-file-excel',
  },
  {
    path: asMenuPath(`${AppPathConsts.ReportPrefix}/${AppPathConsts.ExportSelfEvaluations}`),
    name: '::ExportSelfEvaluations',
    order: 2,
    parentName: '::Reports',
    requiredPolicy: AppPermissionConsts.ExportSelfEvaluationReportResultDefault,
    iconClass: 'fas fa-file-excel',
  },
];

const operatorEvaluationSummariesRoutes = (order: number) => [
  {
    path: asMenuPath(AppPathConsts.OperatorEvaluationSummariesPrefix),
    name: '::OperatorEvaluationSummaries',
    order: order,
    layout: eLayoutType.application,
    requiredPolicy: AppPermissionConsts.OperatorEvaluationSummaryDefault,
    iconClass: 'fas fa-user-check',
  },
];

function asMenuPath(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}
